import { gql } from "@apollo/client";

// Shared by CREATE_GRADE/UPDATE_GRADE so their return shape has one definition.
const GRADE_AUDIT_FIELDS = gql`
  fragment GradeAuditFields on Grade {
    uid
    createdBy
    organizationUid
    name
  }
`;

const UPDATE_GRADE = gql`mutation UpdateGrade($name: String!, $uid: UUID!) {
    updateGradeByUid(input: { gradePatch: { name: $name }, uid: $uid }) {
      grade {
        ...GradeAuditFields
      }
    }
  }
  ${GRADE_AUDIT_FIELDS}`;

const CREATE_GRADE = gql`mutation CreateGrade($name: String!) {
  createGrade(input: { grade: { name: $name } }) {
    grade {
      ...GradeAuditFields
    }
  }
}
${GRADE_AUDIT_FIELDS}`;

const LIST_GRADES = gql`query GetGrades($first: Int = 100, $offset: Int = 0, $filter: GradeFilter){
  allGrades(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [NAME_ASC]) {
    nodes {
      uid
      name
      organizationUid
    }
    totalCount
  }
} `;

const LIST_GRADES_AND_CLASSROOMS_BY_PERIOD = gql`query ListGradesAndClassroomsByPeriod($periodUid: UUID!){
  allPeriodGrades(condition: { periodUid: $periodUid }) {
    nodes {
      gradeByGradeUid {
        classroomsByGradeUid {
          nodes {
            name
            uid
          }
        }
        name
        uid
      }
    }
  }
}`;

const LIST_GRADES_CLASSROOMS_USERS_BY_PERIOD = gql`query ListGradesClassroomsUsersByPeriod($periodUid: UUID!){
  allPeriodGrades(condition: { periodUid: $periodUid }) {
    nodes {
      gradeByGradeUid {
        classroomsByGradeUid {
          nodes {
            name
            uid
            usersByClassroomUid {
              nodes {
                uid
              }
              totalCount
            }
          }
        }
        name
        uid
      }
    }
  }
}`;

const CREATE_PERIOD_GRADE = gql`mutation CreatePeriodGrade($periodUid: UUID!, $gradeUid: UUID!) {
  createPeriodGrade(input: { periodGrade: { periodUid: $periodUid, gradeUid: $gradeUid } }) {
    clientMutationId
  }
}
`;

const DELETE_PERIOD_GRADE = gql`mutation DeletePeriodGrade($periodUid: UUID!, $gradeUid: UUID!) {
  deletePeriodGradeByPeriodUidAndGradeUid(input: {periodUid: $periodUid, gradeUid: $gradeUid}){
    clientMutationId
  }
}
`;

const DELETE_GRADE = gql`mutation DeleteGrade($gradeUid: UUID!) {
  deleteGradeByUid(input: { uid: $gradeUid }){
    grade{
      uid
      name
    }
  }
}
`;

export {
  UPDATE_GRADE,
  CREATE_GRADE,
  LIST_GRADES,
  LIST_GRADES_AND_CLASSROOMS_BY_PERIOD,
  LIST_GRADES_CLASSROOMS_USERS_BY_PERIOD,
  CREATE_PERIOD_GRADE,
  DELETE_PERIOD_GRADE,
  DELETE_GRADE,
};
